module.exports = __webpack_public_path__ + "img/Herz.87e5fe65.jpg";